import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { setAlertFunction } from '../utils/alertService';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');

    const showAlert = (msg, sev = 'info') => {
        setMessage(msg);
        setSeverity(sev);
        setOpen(true);
    };
    setAlertFunction(showAlert);

    const handleClose = () => setOpen(false);

    return (
        <AlertContext.Provider value={{ showAlert }}>
            {children}

            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={handleClose} severity={severity} variant="filled">
                    {message}
                </Alert>
            </Snackbar>
        </AlertContext.Provider>
    );
};

export const useAlert = () => useContext(AlertContext);
